import React, { useEffect, useState } from 'react'
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import PubNub from "pubnub";
import { PubNubProvider } from "pubnub-react";
import { Chat, MessageList, MessageInput } from "@pubnub/react-chat-components";
import { oldgenericApi, genericApi } from '../../../common/apiconfig'
import SimpleChat from '../../../videochat/chat/simple-chat/direct-chat';
import { PatientStudyInfo } from '../common/createSessionPatient'
import Loader from '../../../common/loader';

const Chats = (propsobj) => {
    console.log(propsobj.formValues.studylist, "propsobj.formValues.studylist")
    // let [treatments, setTreatments] = useState(propsobj.formValues.studylist)
    let [data, setData] = useState('')
    let [progress, setProgress] = useState(false);
    let [channel, setChannel] = useState("")
    let [headerText, setHeadertext] = useState("")
    useEffect(async () => {
        // callGetPatientInfo()
        var data = await PatientStudyInfo()
        if (data.length > 0) {
            callDoctorListAPi(propsobj.formValues.patientStudyInfo?.studyID, propsobj.formValues.patientStudyInfo?.siteID)
        } else {
            alert('No study assigned yet to create appointment')
        }
        propsobj.UpdateFormField({ name: "patientissues", value: "" })
    }, []);

    const callDoctorListAPi = async (studyID, siteID) => {
        let requestBody = {
            query: `query {
            getStudySiteContact(studyId: "${studyID}", siteId: "${siteID}") {
              studyId
              siteId
              contactId
              contactName
              role
              primaryContactInd
              email
              phone
              status
              createdBy
              createdTs
              modifiedBy
              modifiedTs
                    }
                  }`
        };

        requestBody = JSON.stringify(requestBody);
        setProgress(true);
        let res = await genericApi('getStudySiteContact', requestBody);
        setProgress(false);
        if (!res) {
            // Error handling
            //console.log('Error site users fetch!')

        } else {
            if (res.data.getStudySiteContact.length) {
                setData(res.data.getStudySiteContact)
            } else {
                setData([])
            }
        }
    }
    console.log(data, "doc data")
    const pubnub = new PubNub({
        "publishKey": process.env.REACT_APP_PUBNUB_PUBLISHKEY,
        "subscribeKey": process.env.REACT_APP_PUBNUB_SUBSCRIBEKEY,
        userId: localStorage.getItem("loggedInUser"),
    });
    const currentChannel = "Default";
    const theme = "light";
    // console.log(sha256(localStorage.getItem("loginUserId")))

    const chatFun = (doctorinfo) => {
        console.log(localStorage.getItem("loginUserId"),propsobj.formValues, "userid patienrt")
        setChannel("dm_" + doctorinfo.contactId + '_' + localStorage.getItem("loginUserId"))
        setHeadertext(`Chat with ${doctorinfo.contactName}`)
    }
    return (
        <div className='row'>
            <Loader progress={progress} />
            <div className="d-flex mb-3 justify-content-end col-md-12">
                <h1 className="mr-auto primary-header">Doctors List</h1>
            </div>
            <div className='col-md-5 chat-list'>
                {
                    data && data?.map((item, i) => {
                        console.log(item, "i")
                        return (

                            // item.patientdata.length > 0 && <><div>{item.planName}</div>
                            <>

                                {/* <div className='chat-patient' onClick={() => chatFun(item)}>
                                    <h6>{item.contactName}</h6>
                                    <div><i>{item.role}</i></div>
                                </div> */}
                                  <div className='chat-patient' onClick={() => chatFun(item)}>{item.contactName} &nbsp; &nbsp;({item.role})</div>

                            </>


                        )
                    })
                }

            </div>
            <div className="chat-container col-md-7">
                <PubNubProvider client={pubnub}>
                    {channel && <SimpleChat clientId={localStorage.getItem("loginUserId")} channel={{ name: channel, clientname: localStorage.getItem("loggedInUser") }} clientname={localStorage.getItem("loggedInUser")} header={headerText} />}
                </PubNubProvider>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        formValues: state.form,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        UpdateFormField: (obj) => {
            return dispatch({
                type: "UpdateFormField",
                value: obj.value,
                name: obj.name,
            });
        },
    };
};
export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(Chats)
);
